import React from "react";
import { NavLink } from "react-router-dom";
import techBanner from "../../assets/images/technology/techBannerImg.png";

const Banner = () => {
  return (
    <section
      className="tw-relative tw-overflow-hidden tw-bg-[#F8FCFF] tw-pt-24 tw-pb-28 lg:tw-pt-36 lg:tw-pb-44"
      id="technology-banner"
    >
      {/* Glow background effect */}
      <div className="hero-img-glow tw-absolute tw-top-1/4 tw-right-0 tw-w-96 tw-h-96 tw-bg-indigo-400/10 tw-rounded-full tw-blur-3xl tw-pointer-events-none" />

      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-relative tw-z-10">
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          
          {/* Left Column (Text & CTA) */}
          <div className="lg:tw-col-span-6 tw-text-left">
            <div className="tw-inline-flex tw-items-center tw-gap-2 tw-mb-6 tw-px-3.5 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-[#5D44FF]/20 tw-bg-[#5D44FF]/5 tw-text-[#5D44FF] tw-text-xs tw-font-semibold tw-tracking-wide">
              ⚙️ Advanced Technology
            </div>
            
            <h1 className="tw-text-4xl sm:tw-text-5xl lg:tw-text-6xl tw-font-extrabold tw-tracking-tight tw-leading-[1.1] tw-mb-6 tw-text-slate-900">
              Tech Up Your <span className="tw-text-[#5D44FF] tw-italic">Sales Game</span>
            </h1>
            
            <p className="tw-text-lg sm:tw-text-xl tw-text-slate-600 tw-leading-relaxed tw-mb-8">
              Welcome to the Future of sales and marketing! Supercharge your outreach and optimize your workflows with our next-generation technology stack.
            </p>
            
            <div className="tw-flex tw-flex-wrap tw-gap-4">
              <NavLink
                to="/signup"
                className="hero-btn-shine tw-inline-flex tw-items-center tw-justify-center tw-px-8 tw-py-3.5 tw-bg-[#5D44FF] hover:tw-bg-indigo-600 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-lg tw-shadow-indigo-500/20 tw-transition-all hover:tw-scale-[1.03]"
              >
                Get Started
              </NavLink>
            </div>
          </div>
          
          {/* Right Column (Mockup Image) */}
          <div className="lg:tw-col-span-6 tw-text-center">
            <img
              src={techBanner}
              alt="Technology Banner"
              className="tw-w-full tw-h-auto tw-max-h-[420px] tw-object-contain hover:tw-scale-[1.01] tw-transition-transform tw-duration-300"
              loading="eager"
            />
          </div>

        </div>
      </div>

      {/* Bottom wave divider */}
      <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-overflow-hidden tw-leading-none">
        <svg className="tw-relative tw-block tw-w-full tw-h-12" viewBox="0 0 1440 320" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,320L48,293.3C96,267,192,213,288,192C384,171,480,181,576,202.7C672,224,768,256,864,224C960,192,1056,96,1152,85.3C1248,75,1344,149,1392,186.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
};

export default Banner;
